import type { NodeViewProps } from '@tiptap/react';

import { cn } from '@repo/lib/cn';
import { NodeViewWrapper } from '@tiptap/react';

import { AudioPlayer } from '@/components/ui/media-player/AudioPlayer';
import { RemoveFloatButton } from '@/components/ui/tiptap/tiptap-ui-primitives/remove-button';

export function AudioNodeComponent(audioPlayerNodeComponentProps: NodeViewProps) {
  const { node, editor, getPos, selected } = audioPlayerNodeComponentProps;
  const isEditable: boolean = editor.isEditable;
  const { src } = node.attrs;
  return (
    <NodeViewWrapper className="tiptap audio relative">
      <AudioPlayer src={src} className={cn('rounded-md border p-2', isEditable && 'pe-7.5 sm:pe-9')} />

      {isEditable && selected && <RemoveFloatButton editor={editor} pos={getPos()} />}
    </NodeViewWrapper>
  );
}
